<template>
    <div class="DialogReportPaid__Component">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">הוספת תרגול ליחידת הלימוד</p>
                <button type="button" class="delete" @click="$emit('close')" />
            </header>
            <section class="modal-card-body">
                <div class="DialogReportPaid__Component__Loading">
                    <b-field label="הזן שם לתרגול">
                        <b-input v-model="model.name"></b-input>
                    </b-field>
                    <b-field label="יחידת לימוד">
                        <FieldInlineSelect label="" :filterable="true" :clearable="true" :optionsAsync="getLessons"
                            v-model="model.lessonId" />
                    </b-field>
                    <b-field v-if="selectedLessonData && selectedLessonData.defaultExerciseCategoryId" label="נושא ברירת מחדל לתרגול">
                        <FieldExerciseCategory :value="selectedLessonData.defaultExerciseCategoryId" :store="store"/>
                    </b-field>
                </div>
            </section>
            <footer class="modal-card-foot">
                <b-button :loading="isLoading" @click="save" label="שמור" type="is-primary" />
                <b-button :disabled="isLoading" label="סגור" @click="$emit('close')" />
            </footer>
        </div>
    </div>
</template>

<script>
import LessonService from "@/services/LessonService";
import FieldInlineSelect from '@/components/Fields/FieldInlineSelect.vue';
import FieldExerciseCategory from '@/components/Fields/FieldExerciseCategory.vue';
import { ToastProgrammatic as Toast } from "buefy";
import CoursesService from "../services/CoursesService";

export default {
    name: "DialogAddExercise",
    props: ["store", "lessonId", "router"],
    components: {
        FieldInlineSelect,
        FieldExerciseCategory
    },
    computed: {
        courseId() {
            return this.store.state.auth.course.id;
        },
    },
    created() {
        if (this.lessonId) this.model.lessonId = this.lessonId;
    },
    data() {
        return {
            submitted: false,
            isLoading: false,
            loading: false,
            selectedLessonData: null,
            model: {
                name: null,
                lessonId: null,
            }
        };
    },
    watch: {
        'model.lessonId': {
            handler(newLessonId) {
                if (newLessonId) {
                    this.fetchLessonData(newLessonId);
                } else {
                    this.selectedLessonData = null;
                }
            },
            immediate: true
        }
    },
    methods: {
        fetchLessonData(lessonId) {
            // If lessonId is an object (from the select), extract the Value
            const id = typeof lessonId === 'object' ? lessonId.Value : lessonId;
            if (!id) return;
            LessonService.getLesson(this.courseId, id)
                .then((res) => {
                    this.selectedLessonData = res.data;
                })
                .catch((error) => {
                    console.error('Failed to fetch lesson data:', error);
                    this.selectedLessonData = null;
                });
        },
        save() {
            this.isLoading = true;
            if (this.lessonId) this.model.lessonId = +this.model.lessonId.Value;
            LessonService.addExercise(this.courseId, {
                Name: this.model.name,
                LessonId: this.model.lessonId,
                status: true
            })
                .then((res) => {
                    Toast.open({
                        type: "is-success",
                        message: "הפעולה בוצעה!",
                        duration: 4000,
                    });
                    this.$emit("close");
                    this.$emit('customEvent');
                    if (this.router) {
                        window.location.href = this.router.resolve({ name: "Exercise", params: { id: res.data.id } }).href;
                    }
                }).catch(() => {
                    Toast.open({
                        type: "is-danger",
                        message: "לא היה ניתן לבצע את הפעולה, יש לפנות לתמיכה הטכנית.",
                        duration: 8000,
                    });
                }).finally(() => {
                    this.isLoading = false;
                });
        },
        getLessons() {
            return () =>
                CoursesService.getCourse(this.courseId, {
                    PageSize: 9999,
                    IsAscending: true,
                    PageNumber: 1,
                    SortedBy: "id",
                    ResultType: 3
                }, true).then((r) =>
                    r.data.items.map((i) => ({ Value: i.id, Text: `${i.id} - ${i.name}` }))
                );
        },
    },
};
</script>

<style scoped lang="scss"></style>
